// In the webpack configuration, the exports loader is used to export a default
// value from this module.
//
// The default export is the build date, in a format suitable for rainbow api version checking.


/*** EXPORTS FROM exports-loader ***/
module.exports = 20251202;